module.exports = "./img/051e9d78f6da101b73793a9c646156e0.png";